module.exports = __webpack_public_path__ + "assets/img/block-a4968cd4.png";